export default __webpack_public_path__ + "static/media/logo.abbc3053.svg";